import React from "react";

const CustomButton = (props) => {
  return (
    <div onClick={props.onClick}
      className="p-1 fs-20 bg-theme fc-white display-flex justify-content-center br-4 mt-4 mb-2 cursor-pointer"
      style={{ width: "inherit" }}
    >
      {props.text}
    </div>
  );
};

export default CustomButton;
